import api from './axios'

export interface FamiliaItem {
  familia: string
  marcas: string[]
  rotulo: string
}

let familiasCache: FamiliaItem[] | null = null

export const carregarFamilias = async (forceRefresh = false): Promise<FamiliaItem[]> => {
  if (!forceRefresh && familiasCache && familiasCache.length > 0) {
    return familiasCache
  }

  try {
    const res = await api.get('/familias')
    const data = Array.isArray(res.data) ? res.data : []
    familiasCache = data
    return data
  } catch (err) {
    console.error('Erro ao carregar famílias:', err)
    return []
  }
}

export const carregarFamiliasPorMarcas = async (marcas: string[]): Promise<FamiliaItem[]> => {
  if (!marcas || marcas.length === 0) {
    return carregarFamilias()
  }

  try {
    const res = await api.get(`/familias?marcas=${encodeURIComponent(marcas.join(','))}`)
    return Array.isArray(res.data) ? res.data : []
  } catch (err) {
    console.error('Erro ao carregar famílias por marcas:', err)
    return []
  }
}
